<template>
	<div v-once id="quickemail">

		<div class="quickemail-wrap">

			<!--MV-->
			<section class="first">
				<div class="renew2_wrapper">
					<h2>ヤギのメール便</h2>
					<div class="renew2_flex">
						<img src="/static/renew2_img/quickemail_img/quickemail01.png" alt="メール文も例文付き、今すぐ履歴書送信"
							class="first-img">
						<div class="first-flexright">
							<div class="first01">
								<p class="first01-title">作成した履歴書を応募先企業にメールで送ることができるサービスです。</p>
								<p class="first01-txt">
									履歴書PDFをダウンロードしなくても、その場で送信完了！メーラーを立ち上げなくても、そのままブラウザでメール文面作成も、履歴書PDFの送付もできます。</p>
							</div>
							<div class="quickemail-cv">
								<a href="/yagiprimeinfo" class="prime_cv-btn"><span>月額550円の</span>ヤギプライムで使い放題！</a>
								<a href="/yagiprimequickemail/info" class="cv-btn">ヤギのメール便をつかう</a>
							</div>
						</div>
					</div>
				</div>
			</section>

			<!--ヤギのメール便の特徴-->
			<section class="renew2_wrapper second">
				<h3>ヤギのメール便の特徴</h3>
				<ul class="second01">
					<li class="feature-item">
						<p class="feature-title"><img src="/static/renew2_img/quickemail_img/count01.png" alt="例文付きで簡単"
								class="feature-icon">例文付きで簡単</p>
						<img src="/static/renew2_img/quickemail_img/feature01.png" alt="例文付きで簡単" class="feature-img">
					</li>
					<li class="feature-item">
						<p class="feature-title"><img src="/static/renew2_img/quickemail_img/count02.png" alt="企業の確認通知"
								class="feature-icon">企業の確認通知</p>
						<img src="/static/renew2_img/quickemail_img/feature02.png" alt="企業の確認通知" class="feature-img">
					</li>
					<li class="feature-item">
						<p class="feature-title"><img src="/static/renew2_img/quickemail_img/count03.png" alt="送信後の取消機能"
								class="feature-icon">送信後の取消機能</p>
						<img src="/static/renew2_img/quickemail_img/feature03.png" alt="送信後の取消機能" class="feature-img">
					</li>
					<li class="feature-item">
						<p class="feature-title"><img src="/static/renew2_img/quickemail_img/count04.png" alt="パスワード付送信"
								class="feature-icon">パスワード付送信</p>
						<img src="/static/renew2_img/quickemail_img/feature04.png" alt="パスワード付送信" class="feature-img">
					</li>
				</ul>
				<ul class="second02">
					<li class="memo-item">履歴書作成サイトヤギッシュで作成した履歴書、職務経歴書以外は添付することができません。</li>
					<li class="memo-item">送信後の取消は可能ですが、応募先の企業側でダウンロードしている可能性があります。</li>
					<li class="memo-item">履歴書PDFを添付ではなく、履歴書PDFをダウンロードするページURLをお送りします。URLは非公開となっており、別途お送りするパスワードが必要です。
					</li>
				</ul>
			</section>
			<!--ヤギのメール便の使い方-->
			<section class="third">
				<ul class="renew2_wrapper second01">
					<li class="feature-item">
						<p class="feature-title"><img src="/static/renew2_img/quickemail_img/count01.png"
								alt="例文付きで簡単にメール送信" class="feature-icon">例文付きで簡単にメール送信</p>
						<img src="/static/renew2_img/quickemail_img/feature01.png" alt="例文付きで簡単にメール送信"
							class="feature-img">
						<p class="feature-txt">メールの文面の例文を利用することができます。自分なりに編集することも可能です。</p>
					</li>
					<li class="feature-item">
						<p class="feature-title"><img src="/static/renew2_img/quickemail_img/count02.png"
								alt="企業が確認すると通知が届く" class="feature-icon">企業が確認すると通知が届く</p>
						<img src="/static/renew2_img/quickemail_img/feature02.png" alt="企業が確認すると通知が届く"
							class="feature-img">
						<p class="feature-txt">応募先企業があなたの履歴書を確認すると、通知がメールで届きます。</p>
					</li>
					<li class="feature-item">
						<p class="feature-title"><img src="/static/renew2_img/quickemail_img/count03.png" alt="送信後に取消機能"
								class="feature-icon">送信後に取消機能</p>
						<img src="/static/renew2_img/quickemail_img/feature03.png" alt="送信後に取消機能" class="feature-img">
						<p class="feature-txt">企業に送信後も、履歴書の間違いに気づいた場合に「取消」機能があります。</p>
					</li>
					<li class="feature-item">
						<p class="feature-title"><img src="/static/renew2_img/quickemail_img/count04.png"
								alt="パスワード付で送信" class="feature-icon">パスワード付で送信</p>
						<img src="/static/renew2_img/quickemail_img/feature04.png" alt="パスワード付で送信" class="feature-img">
						<p class="feature-txt">履歴書PDFをダウンロードするページURLをお送りします。URLは非公開となっており、別途お送りするパスワードが必要です。</p>
					</li>
				</ul>
			</section>
			<!--ヤギッシュサービスの比較-->
			<section class="renew2_wrapper forth">
				<h3>ヤギのメール便の使い方</h3>
				<ul class="forth01">
					<li class="how-item">
						<img src="/static/renew2_img/quickemail_img/how01.png" alt="送信先入力" class="how-img">
						<p class="how-txt">送信先入力</p>
					</li>
					<li class="how-item">
						<img src="/static/renew2_img/quickemail_img/how02.png" alt="支払い" class="how-img">
						<p class="how-txt">支払い</p>
					</li>
					<li class="how-item">
						<img src="/static/renew2_img/quickemail_img/how03.png" alt="送信完了" class="how-img">
						<p class="how-txt">送信完了</p>
					</li>
				</ul>
				<ul class="forth02">
					<li class="memo-item">閲覧通知は選考の合否とは関係がありません。企業によって選考の流れや連絡方法などは異なります。</li>
				</ul>
				<div class="forth03">
					<div class="forth03-01">
						<p class="forth03-01title">送信メール画面</p>
						<img src="/static/renew_img/quickemail/preview01.png" alt="送信メール画面" class="forth03-01img">
						<ul class="forth03-01list">
							<li class="memo-item">お使いのメールソフトによって画面が異なる場合がございます。ご了承ください。</li>
						</ul>
					</div>
					<div class="forth03-01">
						<p class="forth03-01title">企業側ダウンロード画面</p>
						<img src="/static/renew_img/quickemail/preview02.png" alt="企業側ダウンロード画面" class="forth03-01img">
					</div>
					<div class="forth03-02">
						<a href="https://www.yagish.jp/service/quickemail_manual/" target="_blank"
							class="forth03-link">もっと使い方を詳しく見る</a>
					</div>
				</div>
				<div class="quickemail-cv">
					<a href="/yagiprimeinfo" class="prime_cv-btn">ヤギプライムで使い放題！</a>
					<a href="/yagiprimequickemail/info" class="cv-btn">ヤギのメール便をつかう</a>
				</div>
			</section>

			<!--ヤギッシュサービスの比較-->
			<section class="renew2_wrapper fifth">
				<h3>ヤギッシュサービスの比較</h3>
				<div class="renew2_flex renew2_sp_flex fifth_wrap">
					<ul class="fifth01">
						<li class="table-cell table-title" style="height: 66px;"></li>
						<li class="table-cell table-title">印刷</li>
						<li class="table-cell table-title">提出</li>
						<li class="table-cell table-title">スピード</li>
						<li class="table-cell table-title">自分の負担</li>
						<li class="table-cell table-title">金額</li>
					</ul>
					<ul class="fifth01">
						<li class="table-cell">ヤギの<br>宅配便</li>
						<li class="table-cell">◯</li>
						<li class="table-cell">◯</li>
						<li class="table-cell">1-2日</li>
						<li class="table-cell">★☆☆</li>
						<li class="table-cell">1,100円</li>
					</ul>
					<ul class="fifth01 this">
						<li class="table-cell">ヤギの<br>メール便</li>
						<li class="table-cell">×</li>
						<li class="table-cell">◯</li>
						<li class="table-cell">即</li>
						<li class="table-cell">★☆☆</li>
						<li class="table-cell">330円</li>
					</ul>
					<ul class="fifth01">
						<li class="table-cell">コンビニ<br>印刷</li>
						<li class="table-cell">◯</li>
						<li class="table-cell">自分で</li>
						<li class="table-cell">自分で</li>
						<li class="table-cell">★★★</li>
						<li class="table-cell">380円〜</li>
					</ul>
				</div>
			</section>

			<!--よくある質問-->
			<section class="renew2_wrapper sixth">
				<h3>よくある質問</h3>
				<ul class="faqtop3">
					<li class="faqtop3_item">
						<p class="question">履歴書不要だったため、返金していただくことは可能でしょうか？</p>
						<p class="answer">送信完了しているので、返金できません。ユーザー様のご都合により宛先が既読になる前にキャンセルすることは可能です。</p>
					</li>
					<li class="faqtop3_item">
						<p class="question">認証パスワードのメールが届きません。</p>
						<p class="answer">認証パスワードは宛先（応募先企業）に届きます。ヤギのメール便での提出では、宛先にメールが2回届きます。<br>1回目に履歴書等送付の件（ ユーザー様のお名前
							）というタイトルのメールと2回目に【パスワード送信】_履歴書等送付の件（ユーザー様のお名前）のタイトルのメールです。1回目のメールに記載されているURLにアクセスし、2回目に記載されているパスワードを入力することで履歴書の閲覧やダウンロードができるようになります。
						</p>
					</li>
					<li class="faqtop3_item">
						<p class="question">応募先企業が確認したか不安です。</p>
						<p class="answer">【差出人から宛先の既読状況を確認する方法】があります。マイページ
							→「ヤギのメール便」のアイコンをクリックすると宛先（応募先企業）が既読しているかの詳細も閲覧いただけます。テンプレートの内容もご確認いただけます。<br><br>まだ、既読してない場合は、「未」に緑●、既読している場合は、「済」に緑●が付きます。<br><br>履歴書ダウンロード　未･･･済<br>職務経歴書ダウンロード　未･･･済
						</p>
					</li>
					<li class="faqtop3_item">
						<p class="question">サービスの規約を確認したいです。</p>
						<p class="answer">ヤギのメール便の利用規約は<a href="/quickemailterms" target="_blank">こちら</a>からご確認ください。</p>
					</li>
				</ul>
				<div class="quickemail-cv">
					<a href="/yagiprimeinfo" class="prime_cv-btn">ヤギプライムで使い放題！</a>
					<a href="/yagiprimequickemail/info" class="cv-btn">ヤギのメール便をつかう</a>
				</div>
			</section>
		</div>

	</div>
</template>

<style lang="scss" scoped>
#quickemail .renew2_wrapper {
	width: 768px;
}

#quickemail a:hover {
	text-decoration: none;
	opacity: 1;
}

#quickemail h2 {
	font-size: 18px;
	color: #004D40;
	text-align: center;
	margin-bottom: 20px;
}

#quickemail h3 {
	font-size: 16px;
	color: #004D40;
	text-align: center;
	margin-bottom: 20px;
}

#quickemail .first {
	background: #FFFFE8;
	padding: 30px 0;
	margin-bottom: 50px;
}

#quickemail .first01 {
	background: #fff;
	padding: 20px;
	border-radius: 10px;
	margin-bottom: 20px;
}

#quickemail .first01-title {
	color: #E95B10;
	font-weight: bold;
	font-size: 16px;
	margin-bottom: 10px;
}

#quickemail .first .renew2_flex {
	justify-content: space-between;
}

#quickemail .second01 {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	margin-bottom: 20px;
}

#quickemail .feature-item {
	width: calc(100% / 2 - 5px);
	background: #EEF5E8;
	border-radius: 10px;
	margin-bottom: 10px;
}

#quickemail .feature-title {
	background: #004D40;
	color: #fff;
	font-weight: bold;
	border-radius: 10px 10px 0 0;
	padding: 10px;
}

#quickemail .second02,
#quickemail .forth02,
#quickemail .forth03-01list {
	margin-left: 20px;
	text-align: left;
}

#quickemail .memo-item {
	position: relative;
}

#quickemail .memo-item::before {
	position: absolute;
	content: "※";
	left: -20px;
}

#quickemail .forth .memo-item {
	content: none;
}

#quickemail .second {
	margin-bottom: 50px;
}

#quickemail .third {
	background: #EEF5E8;
	padding: 50px 0 20px;
	margin-bottom: 50px;
}

#quickemail .third.second01 {
	margin-bottom: 0;
}

#quickemail .third .feature-item {
	width: 100%;
	background: #fff;
	padding: 20px;
}

#quickemail .third .feature-title {
	background: none;
	color: #004D40;
	padding: 0;
}

#quickemail .forth01 {
	display: flex;
	justify-content: space-between;
	text-align: center;
	color: #004D40;
	font-weight: bold;
	margin-bottom: 20px;
}

#quickemail .how-item {
	position: relative;
	width: calc(100% / 3 - 5px);
	background: #EEF5E8;
	border-radius: 10px;
	padding: 10px;
}

#quickemail .how-item::after {
	position: absolute;
	content: "▶️";
	color: #EEF5E8;
	right: -10px;
	top: calc(50% - 10px);
}

#quickemail .how-item:last-child:after {
	content: none;
}

#quickemail .forth {
	margin-bottom: 50px;
}

#quickemail .forth02 {
	margin-bottom: 50px;
}

#quickemail .forth03-01 {
	margin-bottom: 30px;
	text-align: center;
}

#quickemail .forth03-01title {
	text-align: center;
	font-weight: bold;
	color: #004D40;
}

#quickemail .forth03-02 {
	text-align: center;
	margin-bottom: 50px;
}

#quickemail .forth03-link {
	display: inline-block;
	font-weight: bold;
	border-bottom: 1px solid #004D40;
}

#quickemail .forth03-link:hover {
	color: #E3165C;
	border-bottom: 1px solid #E3165C;
}

#quickemail .quickemail-cv {
	text-align: center;
	display: flex;
	justify-content: space-around;
	align-items: center;
	flex-wrap: wrap;
}

#quickemail .cv-btn {
	position: relative;
	display: inline-block;
	background: #E3165C;
	color: #fff;
	font-size: 18px;
	font-weight: bold;
	width: 300px;
	margin: 0 0 15px;
	padding: 15px 0;
	border-radius: 10px;
	transition-duration: .4s;
}

#quickemail .cv-btn::before {
	content: '';
	width: 13px;
	height: 13px;
	border: 0;
	border-top: solid 2px #fff;
	border-right: solid 2px #fff;
	transform: rotate(45deg);
	position: absolute;
	top: 0;
	right: 20px;
	bottom: 0;
	margin: auto;
}

#quickemail .cv-btn:hover {
	transform: scale(1.1);
}

#quickemail .first .cv-btn {
	width: 100%;
}

#quickemail .fifth {
	text-align: center;
	margin-bottom: 50px;
}

#quickemail .fifth01 {
	width: 25%;
}

#quickemail .table-cell {
	border: 1px solid #EEF5E8;
	padding: 8px 0;
}

#quickemail .table-title {
	font-weight: bold;
}

#quickemail .this {
	border: 3px solid #E3165C;
	font-weight: bold;
}

#quickemail .sixth {
	margin-bottom: 50px;
}

#quickemail .faqtop3 {
	margin-bottom: 50px;
}

#quickemail .faqtop3_item {
	margin-bottom: 20px;
}

#quickemail .question {
	position: relative;
	font-weight: 700;
	color: #004d40;
	padding: 0 0 10px 30px;
}

#quickemail .question::before {
	position: absolute;
	content: "Q";
	color: #0f9934;
	font-size: 1.6rem;
	left: 3px;
	top: -10px;
	opacity: 0.5;
}

#quickemail .answer {
	padding: 30px;
	background: #ffffe8;
	border-radius: 10px;
}

#quickemail .feature-icon {
	width: 20px;
	margin-right: 5px;
}

#quickemail .feature-img {
	width: auto;
	height: 60px;
	display: block;
	margin: 20px auto;
}

#quickemail .how-img {
	width: auto;
	height: 50px;
	margin-bottom: 10px;
}

#quickemail .first-img {
	display: block;
	margin: 0 auto 10px;
}

#quickemail .first-flexright {
	width: 100%;
}


@media screen and (min-width: 641px) {
	#quickemail .first-flexright {
		width: 100%;
	}

	#quickemail .third .feature-item {
		width: calc(100% / 2 - 5px);
	}

	#quickemail .feature-item {
		width: calc(100% / 4 - 5px);
	}

	#quickemail .sixth {
		margin-bottom: 50px;
	}

	#quickemail .first-img {
		width: 300px;
		max-width: 100%;
		object-fit: contain;
	}

	#quickemail .first-flexright {
		width: calc(100% - 320px);
	}

}
</style>
<style>
#quickemail .prime_cv-btn {
	position: relative;
	display: inline-block;
	background: #ffd700;
	color: #404040;
	font-size: 18px;
	font-weight: 700;
	width: 300px;
	margin: 0 0 15px;
	padding: 15px 0;
	border-radius: 10px;
	-webkit-transition-duration: .4s;
	transition-duration: .4s;
}

#quickemail .first .prime_cv-btn {
	width: 100%;
}

#quickemail .prime_cv-btn span {
	font-size: 12px;
}

#quickemail .prime_cv-btn::before {
	content: "";
	width: 13px;
	height: 13px;
	border: 0;
	border-top: 2px solid #404040;
	border-right: 2px solid #404040;
	-webkit-transform: rotate(45deg);
	transform: rotate(45deg);
	position: absolute;
	top: 0;
	right: 20px;
	bottom: 0;
	margin: auto;
}

#quickemail .prime_cv-btn:hover {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}
</style>
<script>
export default {
	data: function () {
		return {
			question1: false,
			question2: false,
			question3: false,
			question4: false,
			question5: false,
			question6: false,
			question7: false,
			question8: false
		}
	},
	computed: {},
	methods: {
		viewAnswer: function (name) {
			console.error(name)
			this.question1 = true
		}
	},
	watch: {},
	mounted: function () { }
}
</script>
